import { ROUTE_PREFIXES } from '@/common/constants/route-prefixes';

const P = ROUTE_PREFIXES.practitioner;

/** Route patterns for router config (relative segments) */
export const practitionerRoutePatterns = {
  dashboard: 'dashboard',
  home: 'home',
  patients: 'patients',
  patientDetails: 'patients/:patientId',
  evaluationDetails: 'patients/:patientId/evaluations/:evaluationId',
  articles: 'articles',
  articleDetails: 'articles/:articleId',
  videos: 'videos',
  videoDetails: 'videos/:videoId',
  trainings: 'trainings',
  trainingDetails: 'trainings/:trainingId',
  notifications: 'notifications',
  profile: 'profile',
  subscription: 'subscription/billing',
  subscriptionSuccess: 'subscription/success',
} as const;

/** Full paths for navigation (navigate, Link) */
export const practitionerRoutes = {
  dashboard: `${P}/dashboard`,
  home: `${P}/home`,
  patients: `${P}/patients`,
  patientDetails: (id: string) => `${P}/patients/${id}`,
  evaluationDetails: (patientId: string, evaluationId: string) =>
    `${P}/patients/${patientId}/evaluations/${evaluationId}`,
  articles: `${P}/articles`,
  articleDetails: (id: string) => `${P}/articles/${id}`,
  videos: `${P}/videos`,
  videoDetails: (id: string) => `${P}/videos/${id}`,
  trainings: `${P}/trainings`,
  trainingDetails: (id: string) => `${P}/trainings/${id}`,
  notifications: `${P}/notifications`,
  profile: `${P}/profile`,
  subscription: `${P}/subscription/billing`,
  subscriptionSuccess: `${P}/subscription/success`,
} as const;
